export default __webpack_public_path__ + "static/media/preferenceCenterFile.d138bc7b.txt";